import { faCircleExclamation, faCircleInfo } from '@fortawesome/pro-solid-svg-icons';

import Banner from '@/components/ui/banner.component';

export function AppointmentReviewPendingBanner() {
  return (
    <Banner className="items-start text-left font-semibold" variant="info" icon={faCircleInfo}>
      <p>A avaliação estará disponível em breve. Fique atento!</p>
    </Banner>
  );
}

export function AppointmentReviewExpiredBanner() {
  return (
    <Banner className="items-start text-left font-semibold" variant="alert" icon={faCircleExclamation}>
      <p>O prazo de 30 dias para avaliar já expirou.</p>
    </Banner>
  );
}
